import type { SubModelType } from "../../../../../common-deprecated/types/GradeType";
import { type SubmodelActionsType, SET_SUBMODELS } from "../actions/SubmodelActions";

export type SubModelReducerType = {
    initialized: boolean;
    list: SubModelType[];
};

export const initialState: SubModelReducerType = {
    initialized: false,
    list: [],
};

const submodelReducer = (
    state: SubModelReducerType = initialState,
    action: SubmodelActionsType,
): SubModelReducerType => {
    switch (action.type) {
        case SET_SUBMODELS:
            return { ...initialState, initialized: true, list: action.submodels };
        default:
            return state;
    }
};

export default submodelReducer;
